import { Coordinates } from './../interfaces/mechanic/ocr-model';
declare var $: any;
declare var unilever: any;
export class BaseComponent {
    initJqueryAction() {
        unilever.initJqueryAction();
    }
    billTrue() {
        unilever.billTrue();
    }
    homePageInit() {
        unilever.homePageInit();
    }

    signInInit(){
        unilever.signInInit();
    }

    giftStoreInit() {
        unilever.giftStoreInit();
    }

    giftListInit() {
        unilever.giftListInit();
    }

    giftReportInit() {
        unilever.giftReportInit();
    }

    loginPhoneInit() {
        unilever.loginPhoneInit();
    }

    loginOtpInit() {
        unilever.loginOtpInit();
    }

    otpKeyupHandle(callback: any){
        unilever.otpKeyupHandle(callback);
    }

    registerInit(){
        unilever.registerInit();
    }

    giveGiftTicketInit(){
        unilever.giveGiftTicketInit();
    }

    customerInforSuccessInit() {
        unilever.customerInforSuccessInit();
    }

    customerInforSaveInit(){
        unilever.customerInforSaveInit();
    }
    customerLuckyInit() {
        unilever.customerLuckyInit();
    }
    customerLuckyGiftSuccessInit() {
        unilever.customerLuckyGiftSuccessInit(); 
    }

    giveGiftInit() {
        unilever.giveGiftInit();

    }

    verifyOtpInit() {
        unilever.verifyOtpInit();
    }

    setBodyBgClass(className: string){
        unilever.setBodyClass(className);
    }

    copyText(text:string){
        unilever.copyText(text);
    }

    executeRandomGift(resultId: string, imageUrl: string, callBack: any){
        unilever.executeRandomGift(resultId, imageUrl, function(){callBack()});
    }

    drawCanvas(url: string, canvasId: string, coords: Coordinates[])
    {
        unilever.drawCanvas(url, canvasId, coords);
    }
}